import type { LucideIcon } from 'lucide-react'
import { Bot } from 'lucide-react'

import { cn } from '@/lib/utils'

const PALETTE = [
  'bg-avatar-1',
  'bg-avatar-2',
  'bg-avatar-3',
  'bg-avatar-4',
  'bg-avatar-5',
  'bg-avatar-6',
] as const

const SIZES = {
  sm: 'size-7 [&_svg]:size-3.5',
  md: 'size-10 [&_svg]:size-5',
  thumb: 'size-12 [&_svg]:size-5',
  lg: 'size-14 [&_svg]:size-7',
  xl: 'size-[72px] [&_svg]:size-8',
} as const

/** Stable palette slot for an id, so one agent keeps one colour everywhere. */
export function avatarColorClass(id: string): (typeof PALETTE)[number] {
  let hash = 0
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0
  return PALETTE[hash % PALETTE.length]
}

interface AgentAvatarProps extends React.ComponentProps<'div'> {
  /** Colour seed: the role / group / thread id. */
  id: string
  icon?: LucideIcon
  size?: keyof typeof SIZES
}

function AgentAvatar({ id, icon: Icon = Bot, size = 'md', className, ...props }: AgentAvatarProps) {
  return (
    <div
      data-slot="agent-avatar"
      aria-hidden="true"
      className={cn(
        'text-avatar-foreground flex shrink-0 items-center justify-center rounded-full',
        avatarColorClass(id),
        SIZES[size],
        className
      )}
      {...props}
    >
      <Icon strokeWidth={2} />
    </div>
  )
}

export { AgentAvatar }
